import React from 'react';
import CloseIconComponent from "../CloseIconComponent";
import './style.scss';
import { chooseService } from '../../../utils';
import { IButtonScenariosInfo } from '../../../services/cayuga/types';

interface TriggerInterface {
  label: string,
  trigger_id: string
}

interface Props {
  triggers: any[],
  onClick: (id: string) => void,
  title: string,
  onClose: () => void,
  style?: {
    [propName: string]: string
  }
}

const TriggersComponent: React.FC<Props> = ({triggers, onClick, title, onClose, style = {}}) => {
  const triggersList = chooseService(
    () => triggers.map(({label, trigger_id}: TriggerInterface) => (
      <div key={trigger_id + title}
           id={(trigger_id + title).replace(/[\\. ,:-]+/g, '')}
           className="camera-triggers__item"
           onClick={(e) => {
             e.preventDefault();
             e.stopPropagation();
             onClick(trigger_id)
           }}
      >
        {
          label
        }
      </div>
    )),
    () => triggers.map((el: IButtonScenariosInfo) => (
      <div key={el["a:EntityID"]}
           id={el["a:EntityID"].replace(/[\\. ,:]+/g, '')}
           className="camera-triggers__item flex al-it-c"
           onClick={(e) => {
             e.preventDefault();
             e.stopPropagation();
             onClick(el["a:EntityID"]);
           }}
      >
        <img src={`data:image/jpeg;base64,${el["a:Icon"]}`} alt=""/>
        {
          el["a:EntityName"]
        }
      </div>
    ))
  )


  return (
    <div className="camera-triggers">
      <div className="camera-triggers__title">
        {title}
        <CloseIconComponent handler={onClose}/>
      </div>
      <div className="camera-triggers__content scroll">
        {
          triggersList.length > 0
            ? triggersList
            : <div className='camera-triggers__no-triggers'>No global triggers</div>
        }
      </div>
    </div>
  );
};


export default TriggersComponent;